import { takeEvery, put } from 'redux-saga/effects';
import {
    UPDATE_LOCATIONS,
    setDepartureLocation,
    setArrivalLocation,
    storeCityDetailRequested,
} from 'app/store/actions';
import { mapCityDetailResponse } from 'app/functions/api';
import { updateLocationSearch } from 'app/functions/environment';

function* onUpdateLocationsWatcher({ fromCityDetails, toCityDetails }) {
    const urlParams = new URLSearchParams(window.location.search);

    yield put(storeCityDetailRequested(mapCityDetailResponse(fromCityDetails)));
    yield put(storeCityDetailRequested(mapCityDetailResponse(toCityDetails)));
    // do not update search mask locations if user is searching for a return trip
    if (!urlParams.get('backRide')) {
        yield put(setDepartureLocation(fromCityDetails.id));
        yield put(setArrivalLocation(toCityDetails.id));
    }
    const DEPARTURE_CITY = 'departureCity';
    const ARRIVAL_CITY = 'arrivalCity';
    urlParams.set(DEPARTURE_CITY, fromCityDetails.id);
    urlParams.set(ARRIVAL_CITY, toCityDetails.id);
    updateLocationSearch(urlParams);
}


export function* onUpdateLocations() {
    yield takeEvery(UPDATE_LOCATIONS, onUpdateLocationsWatcher);
}

